<template>
    <v-list-item>
        <v-list-item-content>
            <div class="stock-area">
                <div class="stock">
                    <div>
                        <div>
                            {{name}}
                            <v-tooltip
                                v-if="comment"
                                right>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    small
                                    v-on="on"
                                    v-bind="attrs"
                                >
                                  mdi-comment
                                </v-icon>
                              </template>
                              <span style="font-size: 12px;">{{comment}}</span>
                            </v-tooltip>
                        </div>
                        <div>
                            {{ numberWithCommas(stock.closePrice) }}
                        </div>
                    </div>
                    <div style="text-align: right">
                        <div class="rate" :class="{'rise': stock.rate > 0, 'down': stock.rate < 0}">
                            <transition :name="(stock.rate >= 0) ? 'rise' : 'down'" mode="out-in">
                                <div :key="stock.rate" transition="rise">
                                    {{ stock.rate }}
                                </div>
                            </transition>
                        </div>
                        <div>
                            {{ getTradePrice(stock.tradePrice) }}
                        </div>
                    </div>
                </div>
                <div style="text-align: center">
                    <CandleStick :stock="stock" />
                </div>
            </div>
        </v-list-item-content>
        <!--<div class="stock">
            <v-list-item-content class="name">
                <div>
                    {{name}}
                </div>
                <div>
                    {{ numberWithCommas(stock.closePrice) }}
                </div>
            </v-list-item-content>
            <v-list-item-content class="content-area">
                <div class="rate" :class="{'rise': stock.rate > 0, 'down': stock.rate < 0}">
                    <transition :name="(stock.rate >= 0) ? 'rise' : 'down'" mode="out-in">
                        <div :key="stock.rate" transition="rise">
                            {{ stock.rate }}
                        </div>
                    </transition>
                </div>
                <div>
                    {{ getTradePrice(stock.tradePrice) }}
                </div>
            </v-list-item-content>
        </div>
        <div style="justify-content: center; text-align: center">
            <CandleStick :stock="stock" />
        </div>-->
        <!--<v-list-item-content class="content-area">
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-end">
                <div>
                    <div class="rate" :class="{'rise': stock.rate > 0, 'down': stock.rate < 0}">
                        <transition :name="(stock.rate >= 0) ? 'rise' : 'down'" mode="out-in">
                            <div :key="stock.rate" transition="rise">
                                {{ stock.rate }}
                            </div>
                        </transition>
                    </div>
                    <div>
                        {{ getTradePrice(stock.tradePrice) }}
                    </div>
                </div>
                <div style="margin-left: 4px">
                    <CandleStick :stock="stock" />
                </div>
            </div>
        </v-list-item-content>-->
    </v-list-item>
</template>

<style>

    .stock-area {
        display: flex;
        flex-direction: column;
        align-items: initial !important;
        min-height: 10px !important;
    }

    /*.stock {
        font-size: 13px;
        min-height: 24px !important;
        display: flex;
        align-content: space-between;
    }*/

    .stock {
        font-size: 13px;
        min-height: 24px !important;
        display: flex;
        justify-content: space-between;
    }

    .rate-info {
        font-size: 13px;
        display: flex;
        justify-content: space-between;
    }

    .header-avg {
        font-size: 14px;
        font-weight: normal;
    }

    .rise {
        color: red;
    }

    .down {
        color: blue;
    }

    .rise2 {
        color: #f38b8b;
    }

    .name {
        padding: 0px;
    }

    .content-area {
        padding: 0px;
        justify-content: flex-end;
        flex-grow: 0.35 !important;
        text-align: right;
    }

    .rate {
        font-size: 14px;
    }

    .rise-enter-active {
        transition: all .3s ease;
    }

    .rise-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .rise-enter, .rise-leave-to {
        transition: opacity 0.8s linear;
        background-color: red;
        color: white;
    }

    .down-enter-active {
        transition: all .5s ease;
    }

    .down-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .down-enter, .down-leave-to {
        transition: opacity 0.8s linear;
        background-color: blue;
        color: white;
    }

</style>

<script>
    import CandleStick from "./CandleStick";
    export default {
        name: 'Stock',
        components: {CandleStick},
        props: ['stock', 'name', 'comment'],
        methods: {
            getTradePrice: function (tradePrice) {
                if (tradePrice === 0) {
                    return 0;
                }
                return this.numberWithCommas((tradePrice / 1000000).toFixed(0));
            },
            numberWithCommas: function (x) {
                if (x !== undefined) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                return 0;
            }
        }
    }
</script>
